module.exports = __webpack_public_path__ + "static/ajisafe-9ec0a7ba5e3b7f5c2584cf7e484d01cb.jpg";